export default {
  nav_home: 'Başlangıç',
  nav_about: 'Hakkımızda',
  nav_services: 'Hizmetler',
  nav_training: 'Eğitimler',
  nav_automotive: 'Otomotiv',
  nav_blog: 'Blog',
  nav_contact: 'İletişim',
  
  hero_badge: 'Kaliteyi ölçmek için değil,Yaşatmak için buradayız.',
  hero_title: 'AXIOM',
  hero_subtitle: 'Kalite Kontrol ve İnsan Kaynakları Danışmanlığı',
  hero_services_btn: 'Hizmetlerimiz',
  hero_contact_btn: 'İletişime Geçin',
  
  about_badge: 'Kurumsal Kimlik',
  about_title: 'AXIOM ile Fark Yaratan Danışmanlık Hizmetleri',
  about_description: 'Kalite kontrol süreçlerinizi optimize ediyor, insan kaynakları yönetiminizi güçlendiriyoruz. Sektöre yeni girişimizle birlikte, deneyimli kadromuz ve yenilikçi yaklaşımımızla yanınızdayız. İşletmenizin başarısı için kalite standartlarını yükseltir, insan kaynakları potansiyelinizi maksimize ederiz.',
  
  services_title: 'Hizmetlerimiz',
  services_subtitle: 'Kalite Kontrol ve Tamir Hizmetleri',
  service1_title: 'Kontrol Ayıklama Tamir ve Rötuş',
  service1_desc: 'Profesyonel kontrol, ayıklama, tamir ve rötuş hizmetleri',
  service2_title: 'Görsel ve Ölçüsel Kontroller',
  service2_desc: 'Detaylı görsel ve ölçüsel kalite kontrol süreçleri',
  service3_title: 'Firewall & CSL1 & CSL2 & CSL3',
  service3_desc: 'Güvenlik ve kalite seviye kontrolleri',
  service4_title: 'Elektronik Ortam & Yazılım & Güncelleme İşlemleri',
  service4_desc: 'Elektronik sistemler için yazılım ve güncelleme hizmetleri',
  service5_title: 'Boya ve Kaplama Kalınlık Kontrolleri',
  service5_desc: 'Boya ve kaplama kalınlık ölçüm ve kontrol hizmetleri',
  service6_title: 'Tahribatlı & Tahribatsız Kontroller',
  service6_desc: 'Malzeme test ve kontrol hizmetleri',
  service_detail_btn: 'Detaylı Bilgi',
  service_custom_packages: 'İhtiyaca özel paketler',
  
  training_badge: 'Eğitim Programları',
  training_title: 'Kurumsal Gelişim Eğitimleri',
  training_subtitle: 'Çalışanlarınızın ve organizasyonunuzun gelişimi için özel olarak tasarlanmış eğitim programları',
  
  auto_badge: 'Uzmanlık Alanımız',
  auto_title: 'Otomotiv Yan Sanayi Kalite Kontrol',
  auto_description: 'Otomotiv sektöründe kritik parçaların kalite kontrolünde uzmanlaşmış ekibimiz, üretim süreçlerinizin her aşamasında yanınızda. ISO/TS 16949 standartlarına uygun denetim ve kontrol süreçleri ile hatasız üretim garantisi sağlıyoruz.',
  auto_quality_rate: '%99.8 Kalite Oranı',
  auto_experience: '15+ Yıl Deneyim',
  auto_motor_title: 'Motor Parçaları',
  auto_motor_desc: 'Piston, supap, krank mili gibi kritik motor parçalarının hassas kontrolü ve kalite güvencesi',
  auto_chassis_title: 'Şasi ve Süspansiyon',
  auto_chassis_desc: 'Taşıyıcı sistem parçalarının mukavemet testleri ve boyutsal doğrulama kontrolleri',
  auto_electric_title: 'Elektrik ve Elektronik',
  auto_electric_desc: 'Kablo demetleri, sensörler ve elektronik bileşenlerin fonksiyonel testleri',
  auto_process_title: 'Kalite Kontrol Sürecimiz',
  auto_process_desc: 'Her parça için detaylı kontrol protokolleri uygulayarak, üretim süreçlerinizde sıfır hata hedefine ulaşmanızı sağlıyoruz.',
  auto_step1_title: 'Giriş Kontrolü',
  auto_step1_desc: 'Hammadde ve yarı mamul kabul kontrolleri',
  auto_step2_title: 'Süreç İçi Kontrol',
  auto_step2_desc: 'Üretim aşamalarında anlık kalite takibi',
  auto_step3_title: 'Nihai Kontrol',
  auto_step3_desc: 'Sevkiyat öncesi son kalite onayı',
  auto_stat1: 'Kalite Oranı',
  auto_stat2: 'Kontrol Edilen Parça',
  auto_stat3: 'İş Ortağı',
  auto_stat4: 'Yıllık Deneyim',
  
  blog_title: 'Blog & İçerikler',
  blog_subtitle: 'Sektörel gelişmeler ve uzman görüşleri',
  blog_all_btn: 'Tüm Yazılar',
  
  cta_title: 'axiom ile\nbaşlayın',
  cta_subtitle: 'Kalite ve insan kaynakları süreçlerinizi\nprofesyonel danışmanlıkla güçlendirin',
  cta_btn: 'Teklif Alın',
  
  contact_title: 'İletişime Geçin',
  contact_subtitle: 'Sorularınız için bize ulaşın, size en kısa sürede dönüş yapalım.',
  contact_email: 'E-posta',
  contact_phone: 'Telefon',
  contact_address: 'Adres',
  form_name: 'Ad Soyad',
  form_name_placeholder: 'Adınız ve soyadınız',
  form_email: 'E-posta',
  form_email_placeholder: 'ornek@email.com',
  form_phone: 'Telefon',
  form_phone_placeholder: '+90 (5__) ___ __ __',
  form_message: 'Mesajınız',
  form_message_placeholder: 'Nasıl yardımcı olabiliriz?',
  form_submit: 'Gönder',
  form_submitting: 'Gönderiliyor...',
  form_success: 'Mesajınız başarıyla gönderildi! En kısa sürede size dönüş yapacağız.',
  form_error: 'Bir hata oluştu. Lütfen tekrar deneyin.',
  form_validation_required: 'Lütfen tüm alanları doldurun.',
  form_validation_email: 'Geçerli bir e-posta adresi girin.',
  form_validation_length: 'Mesajınız 500 karakterden uzun olamaz.',
  
  footer_description: 'Kalite ve güven odaklı danışmanlık hizmetleri ile işletmenizin başarısına katkı sağlıyoruz.',
  footer_services: 'Hizmetler',
  footer_quality: 'Kalite Kontrol',
  footer_hr: 'İK Danışmanlığı',
  footer_training: 'Eğitim',
  footer_audit: 'Denetim',
  footer_corporate: 'Kurumsal',
  footer_about: 'Hakkımızda',
  footer_team: 'Ekibimiz',
  footer_career: 'Kariyer',
  footer_contact: 'İletişim',
  footer_resources: 'Kaynaklar',
  footer_blog: 'Blog',
  footer_references: 'Referanslar',
  footer_faq: 'SSS',
  footer_documents: 'Dökümanlar',
  footer_cta_title: 'Başarıya\nBirlikte\nUlaşalım',
  footer_newsletter: 'Sektörel gelişmelerden haberdar olun',
  footer_email_placeholder: 'E-posta adresiniz',
  footer_copyright: '© 2025 AXIOM Kalite Kontrol ve İnsan Kaynakları Danışmanlığı. Tüm hakları saklıdır.',
  footer_powered: 'Powered by Readdy'
};